<template>
  <div
    v-if="tags.length"
    class="field-tags"
  >
    <h3>{{ headline }}:</h3>{{ ' ' }}
    <span
      v-for="(item, key) in tags"
      :key="key"
    >
      <a
        :href="langPrefix(item.path)"
      >{{ item.name.trim() }}<template v-if="key !== tags.length - 1">,</template></a>&#32;
    </span>
  </div>
</template>

<script>
  import LanguageHelper from '../mixins/LanguageHelper.js'

  export default {
    name: 'FieldTags',
    mixins: [LanguageHelper],
    props: {
      fieldTags: { type: Array, default: () => [] },
      lang: { type: String, default: 'en' },
    },
    computed: {
      headline() {
        return 'Skills'
      },
      tags() {
        return this.fieldTags
      },
    },
  }
</script>

<style>
  .field-tags {
    color: var(--dm-green-dark, #1c7e35);
  }
  .field-tags > h3,
  .field-tags a {
    display: inline-block;
    margin: 0;
    line-height: 1.6;
    font-weight: 400;
    color: var(--dm-green-dark, #1c7e35);
    text-decoration: none;
    font-family: Verdana, "Lucida Sans Unicode", sans-serif;
    font-size: 17px;
  }
  .field-tags > h3 {
    font-weight: 700;
  }
  .field-tags a:hover {
    text-decoration: underline;
  }
</style>
